import { Typography, TypographyOwnProps } from '@mui/material'

const ErrorMessage = (
  props: TypographyOwnProps,
) => {
  return (
    <Typography
      {...props}
      sx={{
        ...props.sx,
        color: 'red.600',
        fontSize: '12px',
        lineHeight: '24px',
        fontWeight: 400,
        minHeight: '24px',
      }}
    />
  )
}

export default ErrorMessage
